import { StyledDescription, StyledSection, StyledTitle } from './styles';
import { whyDoYouNeedData } from './WhyDoYouNeed.data';

export const WhyDoYouNeed = () => {
  return (
    <StyledSection width="small">
      <StyledTitle variant="display_sm">{whyDoYouNeedData.title}</StyledTitle>

      <StyledDescription variant="regular_500">
        {whyDoYouNeedData.description}
      </StyledDescription>
    </StyledSection>
  );
};
